module.exports = __webpack_public_path__ + "static/media/capelli-blanc.f27717fb.png";